import React, { useState, useEffect } from "react";
import { TrendingUp, TrendingDown, Minus, AlertTriangle, FileCheck, Shield, GraduationCap, Truck } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

const WIDGET_ICONS = {
  capa_velocity: AlertTriangle,
  audit_risk: Shield,
  doc_compliance: FileCheck,
  training_compliance: GraduationCap,
  supplier_risk: Truck,
};

const TREND_COLORS = {
  improving: "#4ADE80", healthy: "#4ADE80",
  stable: "#36A9E1",
  worsening: "#F87171", critical: "#F87171",
  warning: "#FBBF24",
};

export default function PredictiveWidgets() {
  const [widgets, setWidgets] = useState([]);

  useEffect(() => {
    fetch(`${API}/api/predictive/widgets`, { credentials: "include" })
      .then(r => r.ok ? r.json() : { widgets: [] })
      .then(d => setWidgets(d.widgets || []));
  }, []);

  if (!widgets.length) return null;

  return (
    <div className="mb-6" data-testid="predictive-widgets">
      <h3 className="text-sm font-semibold text-[#C9A84C] mb-3 flex items-center gap-2">
        <TrendingUp size={16} /> Predictive Intelligence
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-3">
        {widgets.map(w => {
          const Icon = WIDGET_ICONS[w.id] || AlertTriangle;
          const trendColor = TREND_COLORS[w.trend] || "#8B95A5";
          const TrendIcon = w.trend === "improving" || w.trend === "healthy" ? TrendingUp
            : w.trend === "worsening" || w.trend === "critical" ? TrendingDown : Minus;
          return (
            <div key={w.id} className="rounded-xl p-4 border bg-[rgba(255,255,255,0.02)]"
              style={{ borderColor: `${trendColor}30` }} data-testid={`widget-${w.id}`}>
              <div className="flex items-center justify-between mb-2">
                <Icon size={14} style={{ color: trendColor }} />
                <TrendIcon size={14} style={{ color: trendColor }} />
              </div>
              <div className="text-xl font-bold text-white">{w.value}<span className="text-xs text-[#8B95A5] ml-1">{w.unit}</span></div>
              <div className="text-xs text-[#8B95A5] mt-0.5">{w.title}</div>
              <div className="text-[10px] mt-2 px-2 py-1 rounded" style={{ color: trendColor, background: `${trendColor}10` }}>
                {w.prediction}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
